import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import {
    FillsGraphData,
    formatToolbarLegendData,
} from 'widgets/fillsGraph/fillsGraphData';
import './FillsGraphToolbarLegend.scss';
import { FillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';

export interface FillsGraphToolbarLegendProps {
    fillsGraphData: FillsGraphData;
    fillsGraphPortfolioData?: FillsGraphPortfolioData;
    avgExecAndVwapDecimals: number;
}

export default function FillsGraphToolbarLegend(
    props: FillsGraphToolbarLegendProps
) {
    const { numberFormat } = useContext(AppContext);
    const { fillsGraphData, fillsGraphPortfolioData, avgExecAndVwapDecimals } =
        props;

    if (!fillsGraphPortfolioData) {
        return <div />;
    }
    const legendData = formatToolbarLegendData(
        fillsGraphData,
        fillsGraphPortfolioData,
        numberFormat,
        avgExecAndVwapDecimals
    );

    if (!legendData.name) {
        return <div />;
    }

    const subtitle = fillsGraphPortfolioData.hasFullOrderData
        ? `${legendData.boughtOrSold} ${legendData.totalFillQty} of ${legendData.totalOrderQty} (${legendData.percentageFilled}) at an average of ${legendData.avgFillPrice}`
        : `with a total quantity of ${legendData.totalOrderQty}`;

    return (
        <div className="FillsGraphToolbarLegend">
            <div className="title" title={legendData.name}>
                {legendData.name}
            </div>
            <div className="subtitle" title={subtitle}>
                {subtitle}
            </div>
        </div>
    );
}
